{
  "universalform": {
    "timezone": "America/New_York",
    "periods": [
      {
        "label": "Period 1",
        "formId": "69cd762799a90b8f7efa4ed3",
        "idComponent": "69cd762799a90b8f7efa4ee0",
        "open": "2026-04-18T12:00:00",
        "close": "2026-05-31T23:59:00"
      },
      {
        "label": "Period 2",
        "formId": "69d7bdd508962d97b347e475",
        "idComponent": "69d7bdd508962d97b347e485",
        "open": "2026-06-01T00:00:00",
        "close": "2026-06-30T23:59:00"
      },
      {
        "label": "Period 3",
        "formId": "69d7bde27971c8cd54236ac7",
        "idComponent": "69d7bde27971c8cd54236ad4",
        "open": "2026-07-01T00:00:00",
        "close": "2026-07-31T23:59:00"
      },
       {
        "label": "Period 4",
        "formId": "69d7bdf008962d97b347e4da",
        "idComponent": "69d7bdf008962d97b347e4e6",
        "open": "2026-08-01T00:00:00",
        "close": "2026-08-31T23:59:00"
      }
    ]
  }
}

